export enum View {
  Timeline = 'timeline',
  TimelinePragmatic = 'timeline-new',
  List = 'list',
  Cards = 'cards',
  CardsPragmatic = 'cards-new',
  Map = 'map',
  Roster = 'roster',
  RosterPragmatic = 'roster-new'
}

export enum ViewContext {
  Own = 'myActivityPlanning',
  Team = 'activityPlanning'
}
